<template>
  <div :class="['notifications-panel', { visible: isVisible }]">
    <div class="notifications-panel-header">
      <h1>{{$t("notificaciones.titulo")}}</h1>
      <DxButton icon="fa-regular fa-times" @click="$emit('close-notificaciones')" class="close-btn" />
    </div>

    <DxTabPanel height="95%" tabs-position="top" icon-position="top">
      <DxItem :key="1" title="Sin leer" class="tab-item" :disabled="false" icon="fa-regular fa-envelope">
        <NotificacionesList :notificaciones="notificacionesSinLeer" :leida="false" @refrescar-notificaciones="cargarNotificaciones"/>
      </DxItem>
      <DxItem :key="2" title="Leídas" class="tab-item" :disabled="false" icon="fa-regular fa-envelope-open">
        <NotificacionesList :notificaciones="notificacionesLeidas" :leida="true"/>
      </DxItem>
    </DxTabPanel>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted, provide, inject } from 'vue';
import { DxButton } from "devextreme-vue/button";
import DxTabPanel, { DxItem } from 'devextreme-vue/tab-panel';
import NotificacionesList from './NotificacionesList.vue';
import { useApi } from "@/.shared/.api/integration";
import type { NotificacionModel } from '@/.shared/.api/api';

const props = defineProps({
  isVisible: Boolean
});

const emit = defineEmits(['close-notificaciones']);
const api = useApi();
const notificacionesSinLeer = ref<NotificacionModel[]>([]);
const notificacionesLeidas = ref<NotificacionModel[]>([]);
const numNotificacionesSinLeer = inject('numNotificacionesSinLeer', ref(0));

const cargarNotificaciones = async () => {
  await api.callStandardApi("getNotificaciones", { showLoading: false })
    .then(data => {
      notificacionesSinLeer.value = data.NotificacionesSinLeer;
      notificacionesLeidas.value = data.NotificacionesLeidas;
      numNotificacionesSinLeer.value = data.NotificacionesSinLeer.length;
    })
};

provide('numNotificacionesSinLeer', numNotificacionesSinLeer);

onMounted(() => {
  cargarNotificaciones();
  const interval = setInterval(cargarNotificaciones, 60000); // 60000 ms = 1 minuto

  onUnmounted(() => {
    clearInterval(interval);
  });
});
</script>

<style lang="scss">
.notifications-panel .dx-tabpanel .dx-tab {
  flex: 1 1 50%;
  max-width: 50%;
}

.notifications-panel .dx-tabpanel .dx-tab .dx-item-content.dx-tab-content {
  width: 100% !important;
}

</style>